<div
  title="Selecione uma Imagem"
  (click)="typeCes !== typeCesEnum.SHOW ? selectImage() : ''"
  matRipple
  [matRippleDisabled]="this.typeCes === typeCesEnum.SHOW"
  [ngClass]="
    this.typeCes === typeCesEnum.SHOW
      ? 'image-field'
      : 'image-field image-cursor'
  "
  [formGroup]="group"
  fxLayoutAlign="center center"
>
  <div class="image-title" *ngIf="!group.get(config.name)?.getRawValue()">
    SELECIONAR IMAGEM {{ config.label }}
  </div>
  <div
    class="image-title"
    *ngIf="
      group.get(config.name)?.getRawValue() && this.typeCes === typeCesEnum.SHOW
    "
    fxLayout="row"
    fxLayoutGap="8"
  >
    <label fxFlex>{{ config.label }}</label>
    <a [href]="downloadFile()" target="_blank"
      ><mat-icon fxFlex="initial" class="download">download</mat-icon></a
    >
  </div>
  <div
    class="image-title"
    *ngIf="
      group.get(config.name)?.getRawValue() && this.typeCes === typeCesEnum.EDIT
    "
    fxLayout="row"
    fxLayoutGap="8"
  >
    <label fxFlex>TROCAR IMAGEM {{ config.label }}</label>
  </div>
  <input
    accept="image/*"
    #uploadFile
    (change)="upload($event)"
    type="file"
    style="display: none"
  />
  <input type="hidden" [formControlName]="config.name" />
</div>
